var exports = {
  "o": "xcc377c0b--163185--block",
};

module.exports = exports;
